import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

interface MarkdownTextProps {
  children: string;
  className?: string;
  variant?: 'body' | 'compact' | 'tooltip';
}

const variantClasses: Record<NonNullable<MarkdownTextProps['variant']>, string> = {
  body:    'prose prose-sm max-w-none text-foreground prose-strong:text-foreground prose-li:text-foreground',
  compact: 'prose prose-xs max-w-none text-muted-foreground prose-strong:text-muted-foreground prose-li:text-muted-foreground prose-p:my-0.5 prose-ul:my-0.5 prose-li:my-0',
  tooltip: 'prose prose-xs max-w-none text-popover-foreground prose-strong:text-popover-foreground prose-li:text-popover-foreground prose-p:my-0 prose-ul:my-0.5 prose-li:my-0',
};

export function MarkdownText({ children, className, variant = 'body' }: MarkdownTextProps) {
  return (
    <div className={cn(variantClasses[variant], className)}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
